import { useSelector, shallowEqual } from "react-redux";
import { ReduxStore } from "@interfaces/store";
import { useEffect } from "react";
import { consumerActions } from '@store/consumer';
import { useAppDispatch } from "./helperHooks";

export function useConsumerProjectInfo() {
    const info = useSelector(({ consumer: { projectInfo } }: ReduxStore) => projectInfo, shallowEqual);
    const { loaded, loading, error } = info;
    const dispatch = useAppDispatch();

    useEffect(() => {
        if (!loaded && !loading && !error) {
            dispatch(consumerActions.loadProjectInfo());
        }
    }, [dispatch, error, loaded, loading]);

    return info;
}